import { Image } from '@starsoft/common/components';
import { TowerRowCardImageProps } from './props';
import styles from './styles.module.scss';

export default function TowerRowCardImage({
  isSkull,
  position,
  isRevealed,
  wasClicked,
  row,
  rowsCleared,
}: TowerRowCardImageProps) {
  const coinImage = `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/tower/ice/Coin.png`;
  const skullImage = `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/tower/ice/Skull.png`;

  const image = isSkull ? skullImage : coinImage;

  if (!isRevealed) {
    return null;
  }

  return (
    <Image
      width={30}
      height={30}
      bundle
      src={image}
      alt={`tower-image-${position}`}
      className={`${styles.image} ${!wasClicked ? styles['image--not-clicked'] : ''}`}
    />
  );
}
